import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from '~/behaviors/languages';
import { mui } from '~/tools/mui';

const kindToAlertSeverity = (kind: string | null) => {
  const kindToSeverity = {
    info: 'info',
    error: 'error',
  };

  return (kind && kindToSeverity[kind]) || 'info';
};

export const SupportLogoutPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  let message = searchParams.get('message');
  // Fixed Zendesk error message for when team members try to log in, and other errors.
  // It is not helpful for users to see this message, so we replace it with a generic one.
  if (message === 'Please use one of the options below to sign in to Zendesk.') {
    message = t('support.failure.message');
  }
  const kind = searchParams.get('kind');

  return (
    <mui.Box margin={2} width={530}>
      <mui.Grid container spacing={2}>
        <mui.Grid item xs={12}>
          <mui.Alert severity={kindToAlertSeverity(kind)} variant="outlined">
            {message}
          </mui.Alert>
        </mui.Grid>
        <mui.Grid item container justifyContent="center">
          <Link to="/">{t('return.home')}</Link>
        </mui.Grid>
      </mui.Grid>
    </mui.Box>
  );
};
